// libs
import React from 'react';

// components
import AttributeColumnizeWidget from '../AttributeColumnizeWidget';
import AttributeWidget from '../AttributeWidget';
import PlainWidget from '../PlainWidget';

// constants
import { WIDGET_TYPES } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/constants';

// styles
import { Container, ChildComponent } from './styles';

// types
import { IWidget } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/types';

interface IParentWidget {
  widget: IWidget;
}
function ParentWidget({ widget }: IParentWidget) {
  const getWidgetComponent = (widget_data: IWidget, className: string) => {
    const type = widget_data.widget_type;
    switch (type) {
      case WIDGET_TYPES.attributeColumnizeWidget:
        return <AttributeColumnizeWidget widget={widget_data} className={className} />;

      case WIDGET_TYPES.plainCollapsableWidget:
        return (
          <PlainWidget widget={widget_data} showTitle={false} className={className}></PlainWidget>
        );

      case WIDGET_TYPES.attributeWidget:
        return <AttributeWidget widget={widget_data} className={className} />;

      case WIDGET_TYPES.plainWidget:
        return (
          <PlainWidget widget={widget_data} showTitle={true} className={className}></PlainWidget>
        );
    }
  };
  return (
    <Container data-test="comparetest">
      {widget.child_widgets &&
        widget.child_widgets.map((childWidget, id) => (
          <ChildComponent
            key={`parent-widget-child-${childWidget.widget_type}-${id}`}
            showTopBorder={id > 0}
          >
            {getWidgetComponent(childWidget, 'childComponent')}
          </ChildComponent>
        ))}
    </Container>
  );
}

export default ParentWidget;
